import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OverlayService } from '../../../../../services/overlay.service';
import { NewApiHttpService, NewApiResponse } from '../../../../../services/new-api-http.service';
import { UserListComponent } from '../user-list.component';

@Component({
	selector: 'app-edit-user-form',
	templateUrl: './edit-user-form.component.html',
	styleUrls: ['./edit-user-form.component.scss']
})
export class EditUserFormComponent implements OnInit {
	@Input() userData;
	@Output() output = new EventEmitter();
	showResponse = false;
	sending = false;
	sentOk = false;
	email;
	userName;
	isActive = true; // new user by default is added as active
	password;
	company;
	type = 'new';
	tenant_id;
	role_id = 1; // new user by default is added as basic
	userId = -1;
	terminate;

	constructor(private overlay: OverlayService, private userList: UserListComponent, private newApiHttpService: NewApiHttpService) {}

	ngOnInit() {
		if (this.userData) {
			this.userId = this.userData.id;
			this.email = this.userData.email;
			this.userName = this.userData.name;
			this.password = this.userData.password;
			this.company = this.userData.company;
			this.tenant_id = this.userData.tenant_id;
			this.role_id = this.userData.role_id;
			this.isActive = typeof this.userData.active === 'undefined' ? true : this.userData.active;
			this.terminate = typeof this.userData.terminate === 'undefined' ? false : this.userData.terminate;
			this.type = 'edit';
		}
	}

	submitEditUserForm(values) {
		this.sending = true;
		this.updateUser(values);
	}

	updateUser(user) {
		const active = this.isActive ? 1 : 0;

		let data = {
			id: user.id,
			name: user.userName,
			active: active,
			email: user.email,
			company: user.company,
			role: Number(user.role_id)
		};

		if (user.tenant_id) {
			data['tenant_id'] = user.tenant_id;
		}

		if (this.terminate) {
			data['terminate'] = this.terminate;
		}

		let method = 'newApiRequestPut';
		if (user.id == -1) {
			data['password'] = user.password;
			method = 'newApiRequestPost';
		} else {
			// in edit user, password is not required
			if (user.password) {
				data['password'] = user.password;
			}
		}
		this.newApiHttpService[method]('user', data).subscribe(
			(response: NewApiResponse) => {
				this.showResponse = true;
				if (!response || !response.status) {
					this.sentOk = false;
					this.sending = false;
				} else if (response.status) {
					this.sentOk = true;
				}
			},
			(error) => this.overlay.updateOverlay(true, error, 'alert'),
			() => {}
		);
	}

	closeAfterEdit() {
		this.userList.refreshUsers();
		this.userList.showEditModal = false;
	}

	approveTerminate(event: MouseEvent) {
		if (!this.terminate) {
			const sure = confirm(
				`Are you sure you want to terminate all of the components in the ${this.email} account (ID: ${this.userId})?`
			);
			if (!sure) {
				event.preventDefault();
			}
		}
	}

	checkActive() {
		if (this.isActive) {
			this.terminate = false;
		}
	}
}
